var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{attrs:{"id":_vm.id,"disabled":_vm.disabled}},[(_vm.placeholder)?_c('option',{staticClass:"select2-option-fixed"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }